import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { routes, RouteValidation } from './routes';
import Layout from './components/Layout';
import webSocket from './webSocket';
import { subscribeToMessages } from './pages/chat/messageBus';
import { subscribeToAllOrder, subscribeToOrderCreated } from './pages/map/messageBus';
import { toast } from 'react-toastify';
import OrderCreatedToast from './components/OrderCreatedToast';
import OrderAssignedToast from './components/OrderAssignedToast';
import MessageToast from './components/MessageToast';
import { playNotificationSound } from './shared/utils';
import { LocalStorageKey } from './shared/enums';

// import Loader from './components/Loader';

const App = () => {
  const buttonRef = useRef(null);

  useEffect(() => {
    const socketUrl = process.env.REACT_APP_API_URL?.replaceAll('http', 'ws')?.replaceAll('https', 'wss');
    if (socketUrl) {
      webSocket.connect(socketUrl);
    }
    const unsubscribeOrder = subscribeToAllOrder((data) => {
      playNotificationSound();
      toast.success(<OrderAssignedToast order={data} />);
    });

    const unsubscribeOrderCreated = subscribeToOrderCreated((data) => {
      playNotificationSound();
      toast.success(<OrderCreatedToast user={data.user} order={data.order} />);
    });

    const unsubscribeMessage = subscribeToMessages((data) => {
      const currentUser = JSON.parse(localStorage.getItem(LocalStorageKey.USER_DATA));
      if (data?.sender === currentUser?.id) return;

      playNotificationSound();
      toast.info(<MessageToast message={data} />);
    });

    return () => {
      // Clean up on app unmount
      if (webSocket.socket) {
        webSocket.close();
      }
      unsubscribeOrder();
      unsubscribeOrderCreated();
      unsubscribeMessage();
    };
  }, []);

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.click();
    }
  }, []);
  return (
    <Router>
      <button ref={buttonRef} style={{ display: 'none' }} onClick={() => playNotificationSound()}>Play Notification Sound</button>
      {/* <Loader /> */}
      <Routes>
        {
          routes.map((route, index) =>
            <Route
              key={index}
              path={route.path}
              element={
                <RouteValidation isProtected={route.isProtected} protection={route.protection}>
                  {route.layout ?
                    <Layout props={route?.layoutProps ?? {}}>
                      {route.element}
                    </Layout>
                    :
                    route.element
                  }
                </RouteValidation>
              }
            />)
        }
      </Routes>
    </Router >
  );
};

export default App;
